import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { ApiClientError } from 'grabbitbot-legacy-ui'
import { adminClient } from '../../api'
import { AdminNotice } from './adminShared'
import { describeAdminError, type AdminFeedback } from './adminHelpers'
/**
 * Equivalent of legacy `AdminStrategyStatComponent` (route
 * `admin/strategies/:id`, contract #14 view + #15 stat). ARCHIVE: #14
 * always answers 410 (no strategy is ever written) and #15 always `[]` —
 * shown as explicit "not found" rather than a raw error, since a 410 here
 * is the EXPECTED answer, not a failure.
 */
export function AdminStrategyStatPage() {
  const { id = '' } = useParams<{ id: string }>()
  const [notFound, setNotFound] = useState(false)
  const [stat, setStat] = useState<unknown[] | null>(null)
  const [feedback, setFeedback] = useState<AdminFeedback | undefined>()

  useEffect(() => {
    let cancelled = false
    setNotFound(false)
    setStat(null)
    setFeedback(undefined)
    adminClient
      .strategyView(id)
      .catch((err: unknown) => {
        if (err instanceof ApiClientError && err.status === 410) {
          if (!cancelled) setNotFound(true)
          return
        }
        throw err
      })
      .catch((err: unknown) => {
        if (!cancelled) setFeedback(describeAdminError(err))
      })
    adminClient
      .strategyStat(id)
      .then((rows) => {
        if (!cancelled) setStat(rows)
      })
      .catch(() => undefined)
    return () => {
      cancelled = true
    }
  }, [id])

  return (
    <div>
      <div className="portal-page-title">
        <h1>Admin — strategy {id}</h1>
      </div>
      <div className="portal-card">
        <p className="portal-notice portal-notice--info">
          ARCHIVE — the strategy-subscription namespace has no active writer.
        </p>
        <AdminNotice feedback={feedback} />
        {notFound && <p className="portal-text-muted">No such strategy.</p>}
        {!notFound && (
          <>
            <h3>Subscriptions</h3>
            {stat === null ? <p>Loading…</p> : stat.length === 0 ? <p className="portal-text-muted">None.</p> : <pre>{JSON.stringify(stat, null, 2)}</pre>}
          </>
        )}
      </div>
    </div>
  )
}
